var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#13886C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_8419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 26,
    height: 26,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_8419)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.9375,
    cy: 29.875,
    r: 1.625,
    fill: "#E8F6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0063 27.9981L27.2669 27.8194C27.163 27.4859 27.0298 27.1624 26.8688 26.8525L27.2588 26.2025C27.5909 25.6532 27.5036 24.9479 27.0475 24.4962L26.3163 23.765C25.8646 23.3089 25.1593 23.2216 24.61 23.5538L23.96 23.9437C23.6501 23.7827 23.3266 23.6495 22.9931 23.5456L22.8144 22.8063C22.657 22.1852 22.0982 21.7502 21.4575 21.75H20.4175C19.7768 21.7502 19.218 22.1852 19.0606 22.8063L18.8819 23.5456C18.5484 23.6495 18.2249 23.7827 17.915 23.9437L17.265 23.5538C16.7157 23.2216 16.0104 23.3089 15.5588 23.765L14.8275 24.4963C14.3714 24.9479 14.2841 25.6532 14.6162 26.2025L15.0062 26.8525C14.8452 27.1624 14.712 27.4859 14.6081 27.8194L13.8687 27.9981C13.2477 28.1555 12.8127 28.7143 12.8125 29.355V30.395C12.8127 31.0357 13.2477 31.5945 13.8688 31.7519L14.6081 31.9306C14.712 32.2641 14.8452 32.5876 15.0062 32.8975L14.6163 33.5475C14.2841 34.0968 14.3714 34.8021 14.8275 35.2537L15.5588 35.985C16.0104 36.4411 16.7157 36.5284 17.265 36.1963L17.915 35.8062C18.2249 35.9673 18.5484 36.1005 18.8819 36.2044L19.0606 36.9438C19.218 37.5648 19.7768 37.9998 20.4175 38H21.4575C22.0982 37.9998 22.657 37.5648 22.8144 36.9438L22.9931 36.2044C23.3266 36.1005 23.6501 35.9673 23.96 35.8063L24.61 36.1962C25.1593 36.5284 25.8646 36.4411 26.3163 35.985L27.0475 35.2537C27.5036 34.8021 27.5909 34.0968 27.2588 33.5475L26.8688 32.8975C27.0298 32.5876 27.163 32.2641 27.2669 31.9306L28.0063 31.7519C28.6258 31.5923 29.0598 31.0348 29.0625 30.395V29.355C29.0598 28.7152 28.6259 28.1578 28.0063 27.9981L28.0063 27.9981ZM20.9375 33.125C19.1426 33.125 17.6875 31.6699 17.6875 29.875C17.6875 28.0801 19.1426 26.625 20.9375 26.625C22.7324 26.625 24.1875 28.0801 24.1875 29.875C24.1875 30.7379 23.8449 31.5646 23.2352 32.174C22.6255 32.7834 21.7986 33.1255 20.9366 33.125L20.9375 33.125Z",
    fill: "#E8F6F2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8751,
    cy: 20.1251,
    rx: 1.17,
    ry: 1.17,
    fill: "#E8F6F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.18 18.37L35.5706 18.2238C35.4854 17.9559 35.3795 17.6951 35.2537 17.4437L35.5625 16.9156C35.8856 16.3908 35.8085 15.7131 35.3756 15.2744L34.7256 14.6244C34.2898 14.1939 33.6175 14.1136 33.0925 14.4294L32.5563 14.7463C32.3049 14.6205 32.0441 14.5146 31.7763 14.4294L31.63 13.82C31.4819 13.2273 30.949 12.8118 30.3381 12.8125H29.4119C28.801 12.8118 28.2681 13.2273 28.12 13.82L27.9738 14.4294C27.7059 14.5146 27.4451 14.6205 27.1938 14.7462L26.6656 14.4375C26.1417 14.1102 25.4613 14.1877 25.0244 14.6244L24.3744 15.2744C23.9399 15.7083 23.8593 16.3835 24.1794 16.9075L24.4963 17.4438C24.3705 17.6951 24.2646 17.9559 24.1794 18.2238L23.57 18.37C22.9773 18.5181 22.5618 19.051 22.5625 19.6619V20.3363C23.3072 20.6291 23.9059 21.2045 24.2281 21.9369C25.3443 21.4991 26.6137 21.7638 27.4619 22.6112L28.2013 23.3425C29.0488 24.1939 29.3134 25.4656 28.8756 26.5844C29.3132 26.7733 29.6981 27.0661 29.9969 27.4375H30.3381C30.949 27.4382 31.4819 27.0227 31.63 26.43L31.7763 25.8206C32.0441 25.7354 32.3049 25.6295 32.5563 25.5037L33.0844 25.8125C33.6083 26.1398 34.2887 26.0623 34.7256 25.6256L35.3756 24.9756C35.8061 24.5398 35.8864 23.8675 35.5706 23.3425L35.2537 22.8062C35.3795 22.5549 35.4854 22.2941 35.5706 22.0262L36.18 21.88C36.7727 21.7319 37.1882 21.199 37.1875 20.5881V19.6619C37.1882 19.0508 36.7726 18.518 36.1799 18.37L36.18 18.37ZM29.8751 22.9201C28.3314 22.9201 27.0801 21.6687 27.0801 20.1251C27.0801 18.5814 28.3314 17.3301 29.8751 17.3301C31.4187 17.3301 32.6701 18.5814 32.6701 20.1251C32.6701 21.6687 31.4187 22.9201 29.8751 22.9201H29.8751Z",
    fill: "#E8F6F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.46d11225da6ec4cc9c396b29fdae7c26.svg";
export { ForwardRef as ReactComponent };